import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-userprovajder-update-container',
  templateUrl: './userprovajder-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class UserprovajderUpdateContainerComponent <T extends BaseEntity> extends BaseInlineContainer<T>{

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

tempItems: List<T>
 @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

setItems(items){
this.tempItems = items;
}
  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
    }
  }
}
